module.exports = __tmimport("widgets/helpers/two-way-bindings");